<template>
  <div
    class="group relative flex flex-row items-center gap-4 overflow-hidden p-4"
    :class="[!disabled && 'cursor-pointer']"
    @click="toggleValue"
  >
    <BaseIcon v-if="icon" size="24" class="text-on-surface-variant shrink-0">{{ icon }}</BaseIcon>
    <div class="flex shrink grow flex-col select-none">
      <span class="text-title-medium">{{ title }}</span>
      <template v-if="supportingTexts">
        <span
          v-for="text in supportingTexts"
          :key="text"
          class="text-body-medium text-on-surface-variant"
          >{{ text }}</span
        >
      </template>
    </div>
    <span v-if="trailingText" class="text-label-medium text-on-surface-variant">{{
      trailingText
    }}</span>
    <BaseSwitch :value="value" :disabled="disabled" />
    <BaseStateLayer v-if="!disabled" type="surface-neutral" />
    <slot />
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'
  import BaseSwitch from '../switch/BaseSwitch.vue'

  interface Props {
    title: string
    supportingText?: string[] | string
    trailingText?: string
    icon?: string
    disabled?: boolean
  }

  const props = defineProps<Props>()

  const value = defineModel<boolean>({
    required: true,
  })

  const toggleValue = () => {
    if (props.disabled) return
    value.value = !value.value
  }

  const supportingTexts = computed<string[] | undefined>(() => {
    if (!props.supportingText) {
      return undefined
    }
    if (Array.isArray(props.supportingText)) {
      return props.supportingText
    }
    return [props.supportingText]
  })
</script>
